import moment from "moment";

const formatDate = (date) => {
  return date ? moment(date).format('DD.MM.YYYY') : null;
};

export default formatDate;